import LoggedInCard from '../LoggedInCard/LoggedInCard';
import LoggedInExtraCardsSection from '../LoggedInExtraCardsSection/LoggedInExtraCardsSection';
import React from 'react';
import RechargeWalletKuposPayTransfer from '../RechargeWalletKuposPayTransfer/RechargeWalletKuposPayTransfer';
import RechargeWalletKupospayPrime from '../RechargeWalletKupospayPrime/RechargeWalletKupospayPrime';
import RechargeWalletKupospayRecharge from '../RechargeWalletKupospayRecharge/RechargeWalletKupospayRecharge';

function MyAccountMainCardArea(props) {
  const renderExtraSectionItemBody = t => {
    let i;
    props.extraSections.map((val, k) => {
      if (props.menuType && props.menuType == 'TOP_MENU' && val.active) {
        i = k;
      }
    });

    switch (i) {
      case 0:
        return (
          <RechargeWalletKupospayRecharge
            operator={props.operator}
            t={props.t}
            data={props.data}
            actions={props.actions}
            profileData={props.profileData}
          />
        );
      case 1:
        return (
          <RechargeWalletKuposPayTransfer
            t={props.t}
            data={props.data}
            profileData={props.profileData}
            actions={props.actions}
            operator={props.operator}
          />
        );
      case 2:
        return (
          <RechargeWalletKupospayPrime t={props.t} data={props.data} actions={props.actions} />
        );
      default:
        return;
    }
  };

  let t = props.t;
  return (
    <div>
      <div className="flex-row">
        <div className="white-bg"></div>
        <div className="content-container logged-in-main-card-area">
          <LoggedInCard
            actions={props.actions}
            onProfileEdit={props.onProfileEdit}
            profileData={props.profileData}
            history={props.history}
            t={t}
            operator={props.operator}
          />
          <LoggedInExtraCardsSection
            extraSections={props.extraSections}
            profileData={props.profileData}
            history={props.history}
            onSelectionChange={props.onSelectionChange}
            t={t}
            operator={props.operator}
          />
          {renderExtraSectionItemBody(t)}
        </div>
        <div className="grey-bg"></div>
      </div>
    </div>
  );
}

export default MyAccountMainCardArea;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/MyAccountMainCardArea/MyAccountMainCardArea.js